export default {
  en: {
    THREAD_EVENT_START: 'started this thread for {{showName}}',
    THREAD_EVENT_REQUEST_APPROVAL_DATE: 'requested approval for the Time section',
    THREAD_EVENT_REQUEST_APPROVAL_TICKET: 'requested approval for the Tickets section',
    THREAD_EVENT_REQUEST_APPROVAL_OTHER: 'requested approval for the Details section',
    THREAD_EVENT_REQUEST_APPROVAL_SIGN: 'signed off on the show contract',
    THREAD_EVENT_REQUEST_APPROVAL_SHOW_GROUP_SIGN: 'signed off on the series contract',
    THREAD_EVENT_UNLOCK_DATE: 'unlocked the Time section',
    THREAD_EVENT_UNLOCK_TICKET: 'unlocked the Tickets section',
    THREAD_EVENT_UNLOCK_SIGN: 'revoked their signature',
    THREAD_EVENT_APPROVED_DATE: 'approved the Time section',
    THREAD_EVENT_APPROVED_TICKET: 'approved the Tickets section',
    THREAD_EVENT_APPROVED_SIGN: 'signed off and finalized the show contract',
    THREAD_EVENT_SHOW_GROUP_APPROVED_SIGN: 'signed off and finalized the series contract',
    THREAD_EVENT_REQUEST_ADMIN: 'requested help from Side Door',
    THREAD_EVENT_MESSAGE: 'sent a message',
    THREAD_EVENT_IMAGE: 'attached an image',
    THREAD_EVENT_FILE: 'attached a file',
    THREAD_EVENT_UPDATED: 'updated the show details',
    THREAD_EVENT_UPDATED_SHOW_GROUP: 'updated the series details',
    THREAD_EVENT_UPDATED_FIELD: 'updated {{fieldName}}',
    THREAD_EVENT_UPDATED_MULTIPLE_FIELDS: 'updated multiple fields',
    THREAD_EVENT_CANCELLED: '{{userName}} cancelled the show.',
    THREAD_EVENT_SHOW_GROUP_CANCELLED: 'cancelled the series',
    THREAD_EVENT_ADDED_RECORDING_LINK: 'added recording download link',

    THREAD_EVENT_SET_DATE: 'updated the Basics tab',
    THREAD_EVENT_SET_SHOWS: 'updated the Passes tab',
    THREAD_EVENT_SET_PLATFORM: 'updated the Platform tab',
    THREAD_EVENT_SET_TICKET: 'updated the Ticketing tab',
    THREAD_EVENT_SET_PROMO: 'updated the Promo tab',
    THREAD_EVENT_SET_OTHER: 'updated the Details tab',

    NOTIFICATION_TYPE_THREAD_START: 'started a thread for {{showName}}',
    NOTIFICATION_TYPE_THREAD_EVENT: 'updated the thread for {{showName}}',
    NOTIFICATION_TYPE_THREAD_FIELD_UPDATE: 'updated a field for {{showName}}',
    NOTIFICATION_TYPE_MESSAGE: 'sent a message about {{showName}}',
    NOTIFICATION_TYPE_MATCH: 'matched with you',

    CORPORATION: 'Corporation',
    PRIVATE_COMPANY: 'Private Company or Sole Proprietorship',
    PARTNERSHIP: 'Partnership',
    NOT_FOR_PROFIT_ORGANIZATION: 'Non-Profit or Not-For-Profit',
    GOVERNMENT_ENTITY: 'Government Entity',
    PUBLIC_COMPANY: 'Public Company',

    // For v3 shows
    SHOW_EVENT_START: '{{userName}} created a ticketed show.',
    SHOW_EXTERNAL_EVENT_START: '{{userName}} created a show.',
    SHOW_EVENT_SIGNED: '{{userName}} signed off.',
    SHOW_EVENT_PUBLISHED: '{{userName}} signed off and published the show.',
    SHOW_EVENT_UPDATED: '{{userName}} edited the show.',
    SHOW_EVENT_DELETED: '{{userName}} deleted the show.',

    fields: {
      // Basics
      startTime: 'Start time',
      doorsTime: 'Doors time',
      loadTime: 'Load-in time',
      endTime: 'Estimated end',
      latLng: 'Coordinates',
      timezoneOverride: 'Timezone',
      compiledAddress: 'Location (address)',
      hasPublicTickets: 'Public listing enabled',

      // Platform
      onlineShowType: 'Online show type',
      isReplayAvailable: '48hr replay period',
      isLiveStream: 'Live broadcast',

      // Tickets/Passes
      currencyOverride: 'Currency',
      hasSocanFee: 'Performance includes music',
      showSalesRestriction: 'Age group',
      announceOnConfirm: 'Purchases available immediately',
      announceTime: 'Purchase availability date',
      guestListExtra: 'Comp tickets',
      artistSplitPercent: 'Artist take',
      hostSplitPercent: 'Host take',

      // GeoGating
      geoGating: 'Geo-gating restriction',
      includedLocations: 'Included locations',
      excludedLocations: 'Excluded locations',

      // Ticket modal
      minimumPrice: 'Minimum price',
      suggestedPrice: 'Suggested price',
      productName: 'Product',
      description: 'Description',
      hasVariablePrice: 'PWYC-enabled',
      capacity: 'Capacity',

      // Promo
      title: 'Title',
      bioHTML: 'Description',
      publicImageUrl: 'Promo images',
      bandcampUri: 'Bandcamp',
      soundcloudUri: 'Soundcloud',
      spotifyUri: 'Spotify',
      vimeoUri: 'Vimeo',
      youtubeUri: 'Youtube',
      messageFromHost: 'Message to guests (comps)',
      messageFromHostProduct: 'Message to guests',
      tipButtonLabel: 'Custom button label',
      tipButtonUrl: 'Custom button link',

      // Affiliate link modal
      affiliateLinkName: 'Affiliate link',

      // Details
      chatEnabled: 'Chat enabled',
      primaryContactName: 'Contact name',
      primaryContactNumber: 'Contact telephone',
      primaryContactRelationship: 'Contact relationship',
      secondaryContactName: 'Secondary contact name',
      secondaryContactNumber: 'Secondary contact phone',
      secondaryContactRelationship: 'Secondary contact relationship',
      minimumPresaleNumber: 'Minimum presale amount',
      minimumPresaleTime: 'Minimum presale cutoff',
      hasMerch: 'Merch space',
      hasBillet: 'Billet available',
      hasGreenRoom: 'Green room',
      allowsVideographer: 'Photo/video allowed',
      outdoors: 'Outdoors',
      outdoorsRainOrShine: 'Outdoors rain or shine',
      hasOpener: 'Has an opener',
      hasPA: 'PA available',
      hasParking: 'Parking available',

      /**
       * @deprecated
       */
      openerDescription: 'Opener description',

      /**
       * @deprecated
       */
      showPADescription: 'PA description',

      /**
       * @deprecated
       */
      bandMembers: 'Other members',

      /**
       * @deprecated
       */
      artistParkingInstructions: 'Artist parking instructions',

      // Sign off
      willTestStream: 'Will test stream',
      willProvideVideoFile: 'Will provide video file',
      soundCheck: 'Soundcheck prep',
    },
  },
};
